import { call, put, takeEvery, select } from 'redux-saga/effects';
import { defineKqlQuery, searchSubmissions } from '@kineticdata/react';
import { C } from '@kineticdata/bundle-common';
import { actions, types } from '../modules/appendix';
import { List } from 'immutable';

/**
 * Fetches the latest active record for the selected appendix.
 */
export function* fetchAppendixSaga({ payload }) {
  const authenticated = yield select(state => state.app.authenticated);
  const profile = yield select(state => state.app.profile);

  const query = defineKqlQuery()
    .equals(`values[${C.FIELD_STATUS}]`, 'status')
    .equals(`values[${C.FIELD_APPENDIX_ID}]`, 'id');
  if (!profile || !profile.hasInternalCatalogAccess) {
    query.equals(`values[Type]`, 'public');
  }

  const { submissions, error } = yield call(searchSubmissions, {
    kapp: C.KAPP_SLUG_DATASTORE,
    form: C.FORM_SLUG_APPENDIX,
    limit: 1000,
    search: {
      q: query.end()({
        status: 'Active',
        id: payload,
        public: 'Public',
      }),
      include: ['details', 'values', 'form'],
    },
    public: !authenticated,
  });

  if (error) {
    yield put(actions.fetchAppendixFailure({ id: payload, error }));
  } else {
    // Sort returned appendices by most recently updated and take the first one
    const currentAppendix = List(submissions)
      .sortBy(p => p.updatedAt)
      .reverse()
      .first();

    if (!!currentAppendix) {
      yield put(
        actions.fetchAppendixSuccess({
          id: payload,
          data: currentAppendix,
        }),
      );
    } else {
      yield put(
        actions.fetchAppendixFailure({
          id: payload,
          error: {
            statusCode: 404,
            message: `Unable to locate the ${payload} appendix`,
          },
        }),
      );
    }
  }
}

export function* watchAppendix() {
  yield takeEvery(types.FETCH_APPENDIX_REQUEST, fetchAppendixSaga);
}
